import React, { useContext, useEffect, useState, useCallback } from "react";
import environment from "constants/apiConst";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationHeader from "../ConfigurationHeader";
import TableOrder from "components/Tables/TableOrder";
import Pagination from "components/Pagination/Pagination";
import { useSelector } from "react-redux";
import TbodyTariff from "../tables/TbodyTariff";
import { __Post } from "request/Petitions/__Post";
import FormTarif from "../forms/FormTarif";
import FormShowTarif from "../FormShow/FormShowTarif";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

const formEditSub = () => {
  return <FormTarif />;
};

const formShow = () => {
  return <FormShowTarif />;
};

export const TypeTarif = () => {
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);

  const {
    setRequestEdit,
    setRequestCreate,
    setRequestDelete,
    setFormEdit,
    setFormShow,
    update
  } = useContext(ConfigurationCRUDContext);

  const Title = [
    { name: "Tipo de tarifa", order: "name_type_rate" },
    { name: "Descripción de tarifa", order: "name_type_rate" },
    { name: "Estado", order: "status_type_rate" },
    { name: "Acciones", order: null }
  ];

  useEffect(() => {
    setFormEdit(formEditSub);
    setFormShow(formShow);
    setRequestEdit(environment.TYPE_TARIFF_UPDATE);
    setRequestCreate(environment.TYPE_TARIFF_CREATE);
    setRequestDelete(environment.TYPE_TARIFF_DELETE);
  }, [update, page, q]);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configTypeTariff", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.TYPE_TARIFF_GET,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader title="Tipo de tarifas"></ConfigurationHeader>
        {isLoading || (
          <TableOrder
            thead={Title}
            data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
            setData={setCurrentPage}
            loading={isLoading}
            tbodyData={TbodyTariff}
          />
        )}
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
          loading={isLoading}
        />
      </SectionContainerGene>
    </>
  );
};
